module.exports = __webpack_public_path__ + "static/media/santa-misa-370-coromoto.33d5c438.jpg";